var middleUrl = 'http://slczpc.sunray365.com/#'
export default middleUrl 
